import styled from 'styled-components';
import { Switch } from 'antd';

export const StyledSwitch = styled(Switch)``;
